import React, { useEffect } from 'react';
import { useGlobalContext } from './context/GlobalContext';  // Importation correcte
import { useTranslation } from 'react-i18next';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AppRouter from './router/AppRouter';
import CookieBanner from './components/common/CookieBanner';


const App = () => {
  const { store,cookieAccepted } = useGlobalContext();
  const { t } = useTranslation();

  return (
    <>
      <a href="#main-content" className="skip-to-content">
        {t('Aller au contenu principal')}
      </a>
      {store.showCookieAcceptance && !cookieAccepted && (
        <CookieBanner />
      )}
      <Header
        logo={store.logo}
        siteUrl={store.site}
        languages={store.languages}
      />
      <main id="main-content">
        <AppRouter store={store} />
      </main>
      {store && !store.exception && (
        <Footer
          layoutType={store.b2b2c ? 'b2b2c' : 'standard'}
          legalLinks={store.legalLinks}
        />
      )}
    </>



  );
};

export default App;
